import { render } from "./EphemeridesConfigPopup.vue?vue&type=template&id=50eef41d"
import script from "./EphemeridesConfigPopup.vue?vue&type=script&lang=js"
export * from "./EphemeridesConfigPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__